var map = {
	"./Application.jpg": 1760,
	"./Game.jpg": 1761,
	"./Music.jpg": 1762,
	"./Video.jpg": 1763,
	"./Wallpaper.jpg": 1764,
	"./Yummy Recipe.jpg": 1765,
	"./Yummy-Recipe.jpg": 1766
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1759;


//////////////////
// WEBPACK FOOTER
// ./src/assets/miximo/imgs/browse ^\.\/.*\.jpg$
// module id = 1759
// module chunks = 0